import React, { useState, useEffect, useCallback, useContext } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { useJoinGame } from "../../hooks/useJoinGame";
import { UserContext } from "../UserContext";
import Modal from "../modal";
import joinGameGIF from "../../assets/images/join-game.gif";
import Button from "../button";
import { useQuery } from "@apollo/client";
import { GameQuery } from "../../gql/queries";
import { PlayerInfo } from "../../lib/models/PlayerInfo";
import moment from "moment";
import { motion } from "framer-motion";
import { loadPlayerInfo } from "../../lib/utils/mapGameData";
import LoadingIndicator from "../LoadingIndicator";

const JoinGame = () => {
  const { id } = useParams();

  const { loading, data, error } = useQuery(GameQuery, {
    variables: { id },
    fetchPolicy: "no-cache"
  });

  const [players, setPlayers] = useState<PlayerInfo[]>([]);
  const [cantJoinGame, setcantJoinGame] = useState(false);

  useEffect(() => {
    if (data && data.getGame && !loading) {
      console.log("qs", data);
      setPlayers([...loadPlayerInfo(data.getGame)]);

      if (players.length > 4) {
        setcantJoinGame(true);
      }

      console.log("DATE START", moment(data.getGame.DateStart).isAfter());
      if (!moment(data.getGame.DateStart).isAfter()) {
        setcantJoinGame(true);
      }
    }
  }, [data]);

  const history = useHistory();
  const goToGame = useCallback(
    (gameId: string) => {
      history.push(`/game/${gameId}`);
    },
    [history]
  );

  const { user } = useContext(UserContext);
  const [joinGame, joinGameStatus] = useJoinGame(user.id, user.name, id);

  useEffect(() => {
    const { called, loading, data } = joinGameStatus;
    if (called && !loading && data) {
      goToGame(data);
    }
  }, [joinGameStatus, goToGame]);

  function joinGameClickHandle() {
    joinGame();
  }

  const [showJoinGameModal, setJoinGameModal] = useState(true);

  //show loading message
  if (loading || !data || players.length == 0) {
    return <LoadingIndicator />;
  }

  //show cant join message
  if (cantJoinGame) {
    return (
      <motion.div exit={{ opacity: 0 }}>
        <Modal
          title="Can't Join Game..."
          hideClose
          isOpen={showJoinGameModal}
          closeModal={() => setJoinGameModal(false)}
        >
          <div className="join-game-modal">
            <div
              className="image-bar"
              style={{
                backgroundImage: `url(${joinGameGIF})`
              }}
            ></div>
            <div className="copy text-center mx-auto">
              Looks like we cant get you into this game --
            </div>
            <div className="buttons flex items-center justify-center flex-col">
              <Link to="/">
                <Button color="blue">Create or Join One</Button>
              </Link>
            </div>
          </div>
        </Modal>
      </motion.div>
    );
  }

  return (
    <motion.div exit={{ opacity: 0 }}>
      <Modal
        title="Joining Game..."
        hideClose
        isOpen={showJoinGameModal}
        closeModal={() => setJoinGameModal(false)}
      >
        <div className="join-game-modal">
          <div
            className="image-bar"
            style={{
              backgroundImage: `url(${joinGameGIF})`
            }}
          ></div>
          <div className="copy text-center mx-auto">
            Looks like someone is challenging you to some American Dad Trivia.
            Show them what you got.
          </div>
          <div className="buttons flex items-center justify-center flex-col">
            <Button color="blue" onClick={() => joinGameClickHandle()}>
              Continue To Game
            </Button>
          </div>
        </div>
      </Modal>
    </motion.div>
  );
};
export default JoinGame;
